import { useEffect, type JSX } from "react";
import { useLocation } from "react-router-dom";

import CONFIG from "@config/index";
import { buildUrl } from "@utils/url";
import { REDIRECT_URL } from "@/constant/constantsThrougoutProject";
import tokenManager from "@/utils/tokenManager";
import useURLSync from "@/hooks/useURLSync/useURLSync";
import { STORAGE_KEY } from "@/constant/export/storage";

const Auth = ({ children }: { children: JSX.Element }) => {
  const location = useLocation();
  const token = tokenManager.getToken();
  const params = new URLSearchParams(location.search);
  const tokenFromUrl = params.get("t");

  useURLSync();

  useEffect(() => {
    if (!token && !tokenFromUrl) {
      const params = {
        domain: encodeURIComponent(window.location.origin),
        completeUrl: CONFIG.endPoints.auth0 + "/",
        failUrl: CONFIG.endPoints.auth0 + "/register/fail",
        serverLogin: "true",
      };
      sessionStorage.setItem(REDIRECT_URL, window.location.href);
      const loginURL = buildUrl(
        CONFIG.endPoints.userService,
        "/auth/login",
        params
      );
      window.location.href = loginURL;
    }
  }, [token, tokenFromUrl]);

  if (token) {
    return children;
  }

  if (tokenFromUrl) {
    tokenManager.setToken(tokenFromUrl);
    localStorage.removeItem("messages");
    localStorage.removeItem("historyMetadata");
    localStorage.removeItem("sessionInitialized");
    localStorage.removeItem(STORAGE_KEY.AI_ASSISTANT_WS_CLIENT_ID);
    localStorage.removeItem(STORAGE_KEY.AI_ASSISTANT_CONVERSATION_ID);
    localStorage.removeItem(STORAGE_KEY.WS_CLIENT_ID);
    // Remove the token from the URL to avoid it being bookmarked or shared.
    window.history.replaceState(
      {},
      document.title,
      location.pathname + location.hash
    );
    return children;
  }

  // Render null or a loading spinner while the redirect happens
  return null;
};

export default Auth;
